import React, {isValidElement, useCallback, useEffect, useMemo, useRef, useState} from "react";
import classNames from "classnames";
import Collapse from "./Animations/Collapse";
import PropTypes from "prop-types";

import IconArrowDown from "../icons/IconArrowDown";

const Accordion = ({
    initialActive = false,
    content,
    title,
    blockClass,
    id,
    titleTag: TitleTag,
    useOpacity = true,
    onOpenerClick,
    chevronType = 'cross', // 'cross' | 'arrow' | 'none'
    ...props
}) => {
    const [active, setActive] = useState(initialActive);

    useEffect(() => {
        setActive(initialActive);
    }, [initialActive]);

    const accordionRef = useRef();

    const panelClasses = classNames(`rte ${blockClass}__panel`, props.className, {
        [`${blockClass}__panel--active`]: active
    });

    const Content = () => {
        if (isValidElement(content)) {
            return (
                <div className={`${blockClass}__content`}>
                    {content}
                </div>
            );
        }

        return <div className={`${blockClass}__content`} dangerouslySetInnerHTML={{__html: content}}/>;
    };

    const Chevron = useMemo(() => (
        <>
            {chevronType === 'cross' && <div className="cross"/>}
            {chevronType === 'arrow' && (
                <div className="arrow">
                    <IconArrowDown />
                </div>
            )}
        </>
    ), [chevronType]);

    const toggleAccordion = useCallback(() => {
        if (onOpenerClick && typeof onOpenerClick === "function") {
            onOpenerClick();
        }

        setActive(prevActive => !prevActive)
    }, [onOpenerClick])

    const Opener = (
        <button
            type="button"
            onClick={toggleAccordion}
            className={`${blockClass}__button`}
        >
            {title}
            {Chevron}
        </button>
    );

    return (
        <div data-id={id} className={panelClasses} ref={accordionRef}>
            {TitleTag ? (
                <TitleTag className={`${blockClass}__heading`}>
                    {Opener}
                </TitleTag>
            ) : Opener}

            <Collapse open={active} useOpacity={useOpacity} className={`${blockClass}__inner`}>
                <Content/>
            </Collapse>
        </div>
    );
};

Accordion.propTypes = {
    content: PropTypes.any,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    blockClass: PropTypes.string.isRequired,
    titleTag: PropTypes.string,
    useOpacity: PropTypes.bool,
    initialActive: PropTypes.bool
};

export default Accordion;
